<div class="popup">
  <img src="assets/images/icon-emoji-wave.svg" alt="waving hand emoji" />
  <div class="popup__title">
    Hey, you have
    <span>
      <ng-container *ngIf="!isLoading">
        {{ notificationsNumber > 99 ? "99+" : notificationsNumber }}
      </ng-container>
      <ng-container *ngIf="isLoading">
        <i class="fa-spin fas fa-spinner mx-2"></i
      ></ng-container>
    </span>
    new notifications today
  </div>
  <button class="custom-btn" (click)="dialogRef.close(true)">
    Check them out
  </button>
</div>
